/* eslint-disable no-param-reassign */

export const calculateDiscount = (self: {
  promoCode: { isPercent: boolean; value: number } | null
  totalAmt: number
  pdpFees: number
}) => {
  const res = { ...self } as {
    pdpFees: number
    bookingAmount: number
    discount: number
    promoCode: { isPercent: boolean; value: number }
    totalAmt: number
  }
  if (res.promoCode) {
    // checking the promo code exist
    let discountValue = 0
    if (!res.promoCode.isPercent) {
      // checking the promo code amount not in precent
      discountValue = res.promoCode.value || 0
    } else {
      // // if the promo code amount in precent calculation
      const discountPer = res.promoCode.value
      discountValue = discountPer
        ? (res.totalAmt + res.pdpFees) * (discountPer / 100)
        : 0
    }
    if (res.totalAmt - (discountValue || 0) < 0) {
      /**
       * Note: removed split payment related code because we do not have the feature anymore
       * before removing this even though we do not have split feature if block was exicuted every time.
       */

      // if (res.splitAmt > 0) {
      //   res.discount = res.splitAmt
      //   res.splitAmt = 0
      // } else {
      res.discount = res.totalAmt + res.pdpFees

      /**
       * Removing the split payment related code from above was causing the promocode issue when applied promo
       * code was removed so commented below two lines
       */

      // res.totalAmt = 0
      // res.splitAmt = 0
      // }
    } else {
      res.discount = discountValue
      // res.totalAmt = res.totalAmt - (res.discount || 0)
    }
    res.bookingAmount = res.totalAmt
  }
  return res
}

export const getTravelProtectionPolicyCount = (
  adults: number = 0,
  children: number = 0,
): number => {
  const totalGuests = (adults || 0) + (children || 0)
  if (totalGuests <= 0) return 1
  return Math.ceil(totalGuests / 10)
}
